var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-goodhome"},[_c('Heading',{staticClass:"container",attrs:{"level":1}},[_c('BaseImage',{staticClass:"header-goodhome__logo col-12",attrs:{"data":{ src: _vm.goodhomeLogo, alt: 'GoodHome Fundacja' }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }